// // src/components/modules/Dashboard.js

// import React, { useEffect, useState } from "react";
// import { Timesheetapi } from "../../middleware/interceptor";
// // removed arrow from client header per design
// import "../styles/dashboardBoxes.css";

// export const Dashboard = () => {
//   const [loading, setLoading] = useState(false);
//   const [counts, setCounts] = useState({
//     clients: 0,
//     projects: 0,
//     activeProjects: 0,
//     inactiveProjects: 0,
//     activeEmployees: 0,
//     opsClients: 0,
//     oneTimeClients: 0,
//     opsProjects: 0,
//     onetimeProjects: 0,
//     annualProjects: 0,
//   });
//   const [clientDetails, setClientDetails] = useState({
//     allClients: [],
//     opsClients: [],
//     oneTimeClients: [],
//   });
//   const [expandedSections, setExpandedSections] = useState({
//     allClients: false,
//     opsClients: false,
//     oneTimeClients: false,
//   });
//   const [clientProjectCounts, setClientProjectCounts] = useState([]);
//   const maxClientProjectCount = clientProjectCounts.length > 0 ? Math.max(...clientProjectCounts.map(i => i.activeCount)) : 1;

//   const opsClientNames = ["Fobesoft", "Autobuy", "Transcredit", "DLR Flow"];
//   const oneTimeClientNames = ["FreshWork", "Apex", "Inkscribe", "RCK Techiees", "Lease Intake", "GOs N Tow", "LID Supplies"];

//   useEffect(() => {
//     const fetchCounts = async () => {
//       try {
//         setLoading(true);

//         // Clients
//         const clientRes = await Timesheetapi.get(`api/Projects/getclientname`);
//         const clients = clientRes?.data?.Client || [];
//         const uniqueClientIds = Array.from(new Set(clients.map((c) => c.Client_id || c.client_id)));
//         const uniqueClients = uniqueClientIds.map((id) => clients.find((c) => (c.Client_id || c.client_id) === id));

//         // Categorize clients by type
//         const opsClientsList = uniqueClients.filter((c) =>
//           opsClientNames.some((name) => (c?.Client_name || c?.client_name || "").toLowerCase().includes(name.toLowerCase()))
//         );
//         const oneTimeClientsList = uniqueClients.filter((c) =>
//           oneTimeClientNames.some((name) => (c?.Client_name || c?.client_name || "").toLowerCase().includes(name.toLowerCase()))
//         );
//         const opsCount = opsClientsList.length;
//         const oneTimeCount = oneTimeClientsList.length;

//         setClientDetails({
//           allClients: uniqueClients,
//           opsClients: opsClientsList,
//           oneTimeClients: oneTimeClientsList,
//         });

//         // Projects
//         const empId = localStorage.getItem("employee_id") || "";
//         const projectRes = await Timesheetapi.get(`api/Projects/getprojectdetails?Role_id=3&empid=${empId}`);
//         const projects = projectRes?.data?.projects || [];
//         const uniqueProjects = Array.from(new Set(projects.map((p) => p.Project_id || p.projectId)));
//         const totalProjects = uniqueProjects.length;
//         const activeProjects = projects.filter((p) => p.status === 1 || p.status === "1").length;
//         const inactiveProjects = totalProjects - activeProjects;

//         // Count projects by type (1 = OPS, 2 = Onetime, 3 = Annual)
//         const opsProjectsCount = projects.filter((p) => p.Project_type === 1 || p.Project_type === "1").length;
//         const onetimeProjectsCount = projects.filter((p) => p.Project_type === 2 || p.Project_type === "2").length;
//         const annualProjectsCount = projects.filter((p) => p.Project_type === 3 || p.Project_type === "3").length;

//         // compute active project counts per client
//         const clientActiveMap = {};
//         projects.forEach((p) => {
//           const status = p.status ?? p.Status;
//           const isActive = status === 1 || status === "1";
//           const cid = p.client_id ?? p.Client_id ?? p.clientId ?? null;
//           if (!cid) return;
//           if (isActive) {
//             clientActiveMap[cid] = (clientActiveMap[cid] || 0) + 1;
//           }
//         });

//         const clientProjectList = uniqueClients.map((c) => {
//           const id = c?.Client_id ?? c?.client_id;
//           return {
//             id,
//             name: c?.Client_name ?? c?.client_name ?? "Unknown",
//             activeCount: clientActiveMap[id] || 0,
//           };
//         }).sort((a,b) => b.activeCount - a.activeCount);

//         setClientProjectCounts(clientProjectList);

//         // Employees
//         const empRes = await Timesheetapi.post(`api/Projects/GetAllEmployee`);
//         const employees = empRes?.data?.Empdetails || [];
//         const activeEmployees = employees.filter((e) => {
//           if (e.del_employee_status && e.del_employee_status.toString() === "1") return false;
//           if (e.employee_status) return e.employee_status.toString() === "1";
//           return true;
//         }).length;

//         setCounts({
//           clients: uniqueClientIds.length,
//           projects: totalProjects,
//           activeProjects,
//           inactiveProjects,
//           activeEmployees,
//           opsClients: opsCount,
//           oneTimeClients: oneTimeCount,
//           opsProjects: opsProjectsCount,
//           onetimeProjects: onetimeProjectsCount,
//           annualProjects: annualProjectsCount,
//         });
//       } catch (err) {
//         console.error("Error fetching dashboard counts:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCounts();
//   }, []);

//   const toggleSection = (section) => {
//     setExpandedSections((prev) => ({
//       ...prev,
//       [section]: !prev[section],
//     }));
//   };

//   return (
//     <div className="container mx-auto pt-20 p-5">
//       <h2 className="text-2xl font-bold mb-6">Dashboard</h2>

//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 dashboard-grid items-stretch">
//         <div className="p-4 dashboard-card">
//           <div className="flex items-center justify-start mt-5"> 
//             <div>
//               <div className="text-sm text-gray-500">Client</div>
//               <div className="text-2xl font-semibold">{loading ? "..." : counts.clients}</div>
//             </div>
//           </div>

//           {/* <div className="mt-4 small-tiles flex gap-4">
//             <div className="tile" onClick={() => toggleSection("opsClients")}>
//               <div className="tile-label">ops</div>
//               <div className="tile-count">{loading ? "..." : counts.opsClients}</div>
//             </div>

//             <div className="tile" onClick={() => toggleSection("oneTimeClients")}>
//               <div className="tile-label">one time</div>
//               <div className="tile-count">{loading ? "..." : counts.oneTimeClients}</div>
//             </div>
//           </div>

//           {expandedSections.opsClients && (
//             <div className="mt-3 pt-3 border-t text-sm">
//               {clientDetails.opsClients.length > 0 ? (
//                 <ul className="space-y-1">
//                   {clientDetails.opsClients.map((c, idx) => (
//                     <li key={idx} className="text-gray-700">{c?.Client_name || c?.client_name}</li>
//                   ))}
//                 </ul>
//               ) : (
//                 <p className="text-gray-500">No OPS clients</p>
//               )}
//             </div>
//           )} 

//           {expandedSections.oneTimeClients && (
//             <div className="mt-3 pt-3 border-t text-sm">
//               {clientDetails.oneTimeClients.length > 0 ? (
//                 <ul className="space-y-1">
//                   {clientDetails.oneTimeClients.map((c, idx) => (
//                     <li key={idx} className="text-gray-700">{c?.Client_name || c?.client_name}</li>
//                   ))}
//                 </ul>
//               ) : (
//                 <p className="text-gray-500">No One Time clients</p>
//               )}
//             </div>
//           )}*/}
//         </div>

//         {/* OPS and One Time are shown inside the Client card via tiles */}

//         <div className="p-4 dashboard-card">
//           <div className="flex justify-between items-start gap-6">
//             <div>
//               <div className="text-sm text-gray-500">Project</div>
//               <div className="text-2xl font-semibold mt-2">{loading ? "..." : counts.projects}</div>
//             </div>
//             <div className="small-tiles flex gap-4">
//               <div className="tile">
//                 <div className="tile-label">ops</div>
//                 <div className="tile-count">{loading ? "..." : counts.opsProjects}</div>
//               </div>

//               <div className="tile">
//                 <div className="tile-label">onetime</div>
//                 <div className="tile-count">{loading ? "..." : counts.onetimeProjects}</div>
//               </div>

//               <div className="tile">
//                 <div className="tile-label">Annual</div>
//                 <div className="tile-count">{loading ? "..." : counts.annualProjects}</div>
//               </div>
//             </div>
//           </div>

          

//           <div className="mt-4 small-tiles flex gap-4">
//             <div className="tile">
//               <div className="tile-label">Active project</div>
//               <div className="tile-count">{loading ? "..." : counts.activeProjects}</div>
//             </div>

//             <div className="tile">
//               <div className="tile-label">Inactive project</div>
//               <div className="tile-count">{loading ? "..." : counts.inactiveProjects}</div>
//             </div>
//           </div>
//         </div>

//         {/* Active/Inactive project cards removed as requested */}

//         <div className="p-4 dashboard-card">
//           <div className="text-sm text-gray-500  mt-5">Active Employee</div>
//           <div className="text-2xl font-semibold">{loading ? "..." : counts.activeEmployees}</div>
//         </div>
//       </div>

//       <div className="mt-8">
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
//           {/* Box 1: Active Projects by Client List */}
//           <div className="bg-white border rounded p-4">
//             <h3 className="text-lg font-semibold mb-3">Active Projects by Client</h3>
//             <ul className="divide-y" style={{ maxHeight: 270, overflowY: 'auto', paddingRight: 8 }}>
//               {clientProjectCounts.length > 0 ? (
//                 clientProjectCounts.map((item, idx) => (
//                   <li key={idx} className="py-2">
//                     <div className="flex justify-between items-center">
//                       <div className="text-xs text-gray-800">{item.name}</div>
//                       <div className="text-xs text-gray-800 ml-4">{item.activeCount}</div>
//                     </div>
//                     <div className="mt-1">
//                       <div style={{ background: '#f3f4f6', height: 6, borderRadius: 6 }}>
//                         <div
//                           style={{
//                             width: `${Math.round((item.activeCount / (maxClientProjectCount || 1)) * 100)}%`,
//                             height: 6,
//                             background: '#cbd5d8',
//                             borderRadius: 6,
//                           }}
//                         />
//                       </div>
//                     </div>
//                   </li>
//                 ))
//               ) : (
//                 <li className="text-gray-500 text-xs">No active projects</li>
//               )}
//             </ul>
//           </div>

//           {/* Box 2: Client Distribution Donut Chart */}
//           <div className="bg-white border rounded p-4 flex flex-col items-center justify-center">
//             <h3 className="text-lg font-semibold mb-3 w-full">Client Distribution</h3>
//             <div style={{ width: 160, height: 160, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//               {
//                 (() => {
//                   const ops = counts.opsClients || 0;
//                   const one = counts.oneTimeClients || 0;
//                   const total = ops + one || 1;
//                   const opsAngle = (ops / total) * 360;
//                   const cx = 80, cy = 80, radius = 60;
                  
//                   // Calculate OPS end point
//                   const opsEndX = cx + radius * Math.cos((opsAngle - 90) * Math.PI / 180);
//                   const opsEndY = cy + radius * Math.sin((opsAngle - 90) * Math.PI / 180);
                  
//                   // One Time end point (360 degrees)
//                   const oneEndX = cx + radius * Math.cos((-90) * Math.PI / 180);
//                   const oneEndY = cy + radius * Math.sin((-90) * Math.PI / 180);
                  
//                   const largeArc = opsAngle > 180 ? 1 : 0;
                  
//                   const opsPath = `M ${cx} ${cy} L ${cx} ${cy - radius} A ${radius} ${radius} 0 ${largeArc} 1 ${opsEndX} ${opsEndY} Z`;
//                   const onePath = `M ${cx} ${cy} L ${opsEndX} ${opsEndY} A ${radius} ${radius} 0 ${1 - largeArc} 1 ${oneEndX} ${oneEndY} Z`;
                  
//                   return (
//                     <svg width="160" height="160" viewBox="0 0 160 160">
//                       {/* OPS slice - Blue */}
//                       <path d={opsPath} fill="rgba(56,189,248,0.9)" stroke="white" strokeWidth="2" />
                      
//                       {/* One Time slice - Green */}
//                       <path d={onePath} fill="rgba(34,197,94,0.9)" stroke="white" strokeWidth="2" />
                      
//                       {/* Center text */}
//                       <text x="80" y="88" textAnchor="middle" fontSize="24" fontWeight={700} fill="#111">{total}</text>
//                     </svg>
//                   );
//                 })()
//               }
//             </div>

//             <div style={{ marginTop: 12, width: '100%' }}>
//               <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4, fontSize: 12 }}>
//                 <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
//                   <span style={{ width: 8, height: 8, background: 'rgba(56,189,248,0.9)', borderRadius: 4, display: 'inline-block' }} />
//                   <span style={{ color: '#374151' }}>OPS</span>
//                 </div>
//                 <div style={{ color: '#374151' }}>{counts.opsClients || 0}</div>
//               </div>

//               <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12 }}>
//                 <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
//                   <span style={{ width: 8, height: 8, background: 'rgba(34,197,94,0.9)', borderRadius: 4, display: 'inline-block' }} />
//                   <span style={{ color: '#374151' }}>One Time</span>
//                 </div>
//                 <div style={{ color: '#374151' }}>{counts.oneTimeClients || 0}</div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// src/components/modules/Dashboard.js
// "My Dashboard" — personal timesheet view (MTD / missed days / YTD) + org overview.

// src/components/modules/Dashboard.js
// "My Dashboard" — personal timesheet view (MTD / missed days / YTD) + org overview.

// src/components/modules/Dashboard.js
// "My Dashboard" — personal timesheet view (MTD / missed days / YTD) + org overview.

import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { createPortal } from "react-dom";
import { useMsal } from "@azure/msal-react";
import { FiAlertTriangle, FiPlus, FiChevronRight, FiSearch, FiUsers, FiShield, FiUser } from "react-icons/fi";
import { buildDashboardStats, toISO, HOURS_PER_DAY } from "./dashboardStats";
import { fetchMyEntries, fetchHolidays, fetchOrgCounts, NotConfiguredError } from "./dashboardApi";
import { fetchActiveClients, periodRange } from "./Utilizationapi.js";

// Roles that get the "Admin view" (Clients + Organization overview). 3 = ADMIN.
const ADMIN_ROLE_IDS = ["3"];

// Id of an empty element in Header.js, next to "Hi, <name>". Dashboard buttons render there when it exists.
const HEADER_SLOT_ID = "header-actions";

// Design tokens (match the Figma/Design artifact)
const C = {
  primary: "#1D5FD1",
  nonBill: "#9DB8E8",
  track: "#F1F3F7",
  warn: "#C2410C",
  warnSoft: "#FDE6D6",
  warnBorder: "#F6C9A8",
};

const fmt = (n) => Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 1 });
const longDate = (d) => d.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
const shortDate = (d) => d.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" });
const greeting = () => {
  const h = new Date().getHours();
  return h < 12 ? "Good morning" : h < 17 ? "Good afternoon" : "Good evening";
};

// Calendar cell styles — full class strings so Tailwind JIT picks them up.
const CELL = {
  blank: "bg-transparent",
  off: "bg-[#F1F3F7] text-[#8A93A3]",
  logged: "bg-[#E3ECFB] text-[#164AA6]",
  missed: "bg-[#FDE6D6] text-[#9A3412] font-bold border-[1.5px] border-[#EA7A3A]",
  today: "bg-white text-[#0F172A] font-bold border-2 border-[#1D5FD1]",
  future: "bg-white text-[#8A93A3] border border-dashed border-[#D5DAE3]",
};
const CELL_LABEL = { off: "Weekend / holiday", logged: "Logged", missed: "Missed", today: "Today", future: "Upcoming" };

// ── Small building blocks ────────────────────────────────────────────
const Card = ({ as: Tag = "div", className = "", children, ...rest }) => (
  <Tag className={`bg-white border border-[#E6E9EF] rounded-[14px] ${className}`} {...rest}>{children}</Tag>
);

const Swatch = ({ color, round }) => (
  <span aria-hidden="true" className={`inline-block w-[10px] h-[10px] shrink-0 ${round ? "rounded-full" : "rounded-[3px]"}`} style={{ background: color }} />
);

const Kpi = ({ label, swatch, value, unit, sub, warn }) => (
  <Card className={`p-5 flex flex-col gap-1.5 ${warn ? "!border-[#F6C9A8]" : ""}`}>
    <span className={`text-[13px] flex items-center gap-2 ${warn ? "text-[#9A3412]" : "text-[#5B6474]"}`}>
      {swatch && <Swatch color={swatch} round={warn} />}{label}
    </span>
    <span className={`text-[32px] font-semibold leading-tight ${warn ? "text-[#C2410C]" : "text-[#0F172A]"}`}>
      {value}
      {unit && <span className={`text-[16px] font-medium ${warn ? "text-[#9A3412]" : "text-[#5B6474]"}`}> {unit}</span>}
    </span>
    {sub && <span className={`text-[12px] ${warn ? "text-[#7C2D12]" : "text-[#5B6474]"}`}>{sub}</span>}
  </Card>
);

const Legend = ({ color, label, value, warn }) => (
  <div className="flex flex-col gap-1">
    <span className={`text-[12px] flex items-center gap-1.5 ${warn ? "text-[#9A3412]" : "text-[#5B6474]"}`}>
      <Swatch color={color} />{label}
    </span>
    <span className={`text-[18px] font-semibold ${warn ? "text-[#C2410C]" : ""}`}>{value}</span>
  </div>
);

const OrgTile = ({ label, value, sub }) => (
  <div className="bg-white border border-[#E6E9EF] rounded-[12px] p-4 flex flex-col gap-0.5">
    <span className="text-[12px] text-[#5B6474]">{label}</span>
    <span className="text-[22px] font-semibold">{value}</span>
    {sub && <span className="text-[11px] text-[#5B6474]">{sub}</span>}
  </div>
);

// ── Component ────────────────────────────────────────────────────────
export const Dashboard = () => {
  const navigate = useNavigate();
  const [entries, setEntries] = useState([]);
  const [entriesState, setEntriesState] = useState("loading"); // loading | ready | error | not_configured
  const [holidays, setHolidays] = useState([]);
  const [org, setOrg] = useState(null);
  const [projects, setProjects] = useState([]);
  const [projState, setProjState] = useState("loading"); // loading | ready | error
  const [projSearch, setProjSearch] = useState("");
  const [showAllProjects, setShowAllProjects] = useState(false);

  const today = useMemo(() => new Date(), []);
  const empId = localStorage.getItem("employee_id") || "";
  const isAdmin = ADMIN_ROLE_IDS.includes(String(localStorage.getItem("emp_role_id") || ""));

  // Admin view lives in the URL (?view=admin) so "Back to dashboard" from Utilization returns to it
  const [params, setParams] = useSearchParams();
  const adminView = isAdmin && params.get("view") === "admin";
  const toggleView = () => {
    const next = new URLSearchParams(params);
    if (adminView) next.delete("view"); else next.set("view", "admin");
    setParams(next, { replace: true });
  };

  // Find the header slot (Header may mount after this page)
  const [headerSlot, setHeaderSlot] = useState(null);
  useEffect(() => {
    let tries = 0;
    let timer;
    const find = () => {
      const el = document.getElementById(HEADER_SLOT_ID);
      if (el) setHeaderSlot(el);
      else if (tries++ < 20) timer = setTimeout(find, 100);
    };
    find();
    return () => clearTimeout(timer);
  }, []);
  // Logged-in user's name: Microsoft sign-in account first, then common localStorage keys.
  const { accounts } = useMsal();
  const fullName =
    accounts?.[0]?.name ||
    localStorage.getItem("employee_name") ||
    localStorage.getItem("emp_name") ||
    localStorage.getItem("name") ||
    "";
  // "Rajkumar S" → "Rajkumar"; "S, Rajkumar" (Last, First) → "Rajkumar"
  const firstName = (fullName.includes(",") ? fullName.split(",")[1] : fullName).trim().split(/\s+/)[0] || "";

  useEffect(() => {
    let cancelled = false;

    Promise.all([fetchMyEntries(empId), fetchHolidays(new Date().getFullYear())])
      .then(([mine, hol]) => {
        if (cancelled) return;
        setEntries(mine.entries);
        setHolidays([...new Set([...hol, ...mine.offDates])]);
        setEntriesState("ready");
      })
      .catch((err) => {
        if (cancelled) return;
        if (err instanceof NotConfiguredError) { console.warn(err.message); setEntriesState("not_configured"); }
        else { console.error("Timesheet entries load failed:", err); setEntriesState("error"); }
      });

    return () => { cancelled = true; };
  }, [empId]);

  // Admin-only data: loaded the first time Admin view is opened
  // (a ref, not state: setting state here would re-run this effect and cancel the requests)
  const adminLoadedRef = useRef(false);
  useEffect(() => {
    if (!adminView || adminLoadedRef.current) return undefined;
    adminLoadedRef.current = true;
    let cancelled = false;

    fetchOrgCounts(empId)
      .then((c) => { if (!cancelled) setOrg(c); })
      .catch((err) => console.error("Org overview load failed:", err));

    // Clients with active projects + this month's hours (same API as the Utilization page)
    fetchActiveClients(periodRange("month", new Date()))
      .then((list) => { if (!cancelled) { setProjects(list); setProjState("ready"); } })
      .catch((err) => { console.error("Active clients load failed:", err); if (!cancelled) setProjState("error"); });

    return () => { cancelled = true; adminLoadedRef.current = false; };
  }, [adminView, empId]);

  const s = useMemo(() => buildDashboardStats(entries, { today, holidays }), [entries, today, holidays]);
  const loading = entriesState === "loading";
  const v = (x) => (loading ? "…" : x);

  const goFill = (iso) => navigate(iso ? `/timesheets?date=${iso}` : "/timesheets");
  // Client click → Utilization page, this month, that client selected
  const openClient = (id) => navigate(`/utilization?mode=month&client=${id}&from=dashboard`);

  const PROJECTS_PREVIEW = 8;
  const projQuery = projSearch.trim().toLowerCase();
  const projFiltered = projQuery
    ? projects.filter((p) => (p.client_name || "").toLowerCase().includes(projQuery))
    : projects;
  const projShown = showAllProjects || projQuery ? projFiltered : projFiltered.slice(0, PROJECTS_PREVIEW);
  const maxProjectHours = Math.max(1, ...projects.map((p) => p.total_hours || 0));
  const monthName = today.toLocaleDateString("en-GB", { month: "long" });
  const monthYear = today.toLocaleDateString("en-GB", { month: "long", year: "numeric" });

  // Stacked progress bar for this month (scaled to whichever is bigger: expected or logged)
  const barBase = Math.max(s.mtd.expected, s.mtd.logged) || 1;
  const pct = (n) => `${(n / barBase) * 100}%`;
  const maxProject = s.projects[0]?.hours || 1;
  const maxMonth = Math.max(1, ...s.months.map((m) => m.billable + m.nonBillable));
  const CHART_PX = 170;

  const actions = (
    <div className="flex flex-wrap items-center gap-2.5" style={{ fontFamily: "'Poppins', system-ui, sans-serif" }}>
      {isAdmin && (
        <button type="button" onClick={toggleView} aria-pressed={adminView}
          className={`min-h-[40px] px-4 rounded-[10px] text-[14px] font-medium cursor-pointer flex items-center gap-2 border ${adminView ? "bg-[#E3ECFB] border-[#BFD3F6] text-[#164AA6]" : "bg-white border-[#D5DAE3] text-[#0F172A] hover:bg-[#F8FAFC]"}`}>
          {adminView ? <FiUser aria-hidden="true" /> : <FiShield aria-hidden="true" />}
          {adminView ? "My view" : "Admin view"}
        </button>
      )}
      <button type="button" onClick={() => navigate("/timesheets")}
        className="min-h-[40px] px-4 rounded-[10px] border border-[#D5DAE3] bg-white text-[14px] font-medium text-[#0F172A] cursor-pointer hover:bg-[#F8FAFC]">
        View timesheets
      </button>
      <button type="button" onClick={() => goFill(toISO(today))}
        className="min-h-[40px] px-4 rounded-[10px] border-0 bg-[#1D5FD1] hover:bg-[#164AA6] text-white text-[14px] font-semibold cursor-pointer flex items-center gap-2">
        <FiPlus aria-hidden="true" className="text-[16px]" /> Log time today
      </button>
    </div>
  );

  return (
    <div className="pt-6 px-[clamp(16px,3vw,40px)] pb-12 bg-[#F4F6FA] min-h-screen text-[#0F172A]" style={{ fontFamily: "'Poppins', system-ui, sans-serif" }}>
      <div className="max-w-[1180px] mx-auto flex flex-col gap-6">

        {/* Greeting (top-left). Buttons go to the header bar, next to "Hi, <name>" */}
        <header className="flex flex-wrap items-start justify-between gap-4">
          <div className="flex flex-col gap-1">
            <p className="m-0 text-[13px] text-[#5B6474]">
              {longDate(today)}
              {adminView && <span className="ml-2 align-middle text-[11px] font-semibold text-[#164AA6] bg-[#E3ECFB] rounded-full px-2 py-0.5">Admin view</span>}
            </p>
            <h1 className="m-0 text-[28px] font-semibold tracking-[-0.01em]">
              {greeting()}{firstName ? `, ${firstName}` : ""}
            </h1>
          </div>
          {/* Fallback when Header.js has no slot yet */}
          {!headerSlot && actions}
        </header>
        {headerSlot && createPortal(actions, headerSlot)}

        {/* ── My view (everyone) ── */}
        {!adminView && (<>
        {entriesState === "not_configured" && (
          <div role="status" className="rounded-[12px] border border-[#D5DAE3] bg-white px-4 py-3 text-[13px] text-[#5B6474]">
            Personal timesheet figures aren't connected yet (set <code>myTimesheetEntries</code> in dashboardApi.js).
          </div>
        )}

        {entriesState === "error" && (
          <div role="alert" className="rounded-[12px] border border-[#F6C9A8] bg-[#FFF4EC] px-4 py-3 text-[13px] text-[#7C2D12]">
            Couldn't load your timesheet entries. The figures below may be incomplete — try refreshing.
          </div>
        )}

        {/* Missed timesheet alert */}
        {!loading && s.missedDays.length > 0 && (
          <section aria-label="Missed timesheets alert" className="flex flex-wrap items-center gap-4 bg-[#FFF4EC] border border-[#F6C9A8] rounded-[14px] px-5 py-4">
            <div aria-hidden="true" className="w-10 h-10 rounded-full bg-[#FDE6D6] text-[#C2410C] flex items-center justify-center shrink-0">
              <FiAlertTriangle className="text-[20px]" />
            </div>
            <div className="flex-[1_1_320px] flex flex-col gap-0.5">
              <strong className="text-[15px] text-[#9A3412]">
                You have {s.missedDays.length} missed timesheet{s.missedDays.length > 1 ? "s" : ""} this month
              </strong>
              <span className="text-[13px] text-[#7C2D12]">
                {s.missedDays.map((m) => shortDate(m.date)).join(" · ")} — {fmt(s.missedDays.length * HOURS_PER_DAY)} h not logged.
                {" "}Submit before the month closes on {shortDate(s.monthClose)}.
              </span>
            </div>
            <button type="button" onClick={() => goFill(s.missedDays[0].iso)}
              className="min-h-[44px] px-[18px] rounded-[10px] border-0 bg-[#C2410C] hover:bg-[#9A3412] text-white text-[14px] font-semibold cursor-pointer">
              Fill missed days
            </button>
          </section>
        )}

        {/* KPI tiles */}
        <section aria-label="Key figures" className="grid gap-4 [grid-template-columns:repeat(auto-fit,minmax(220px,1fr))]">
          <Kpi label="MTD billable" swatch={C.primary} value={v(fmt(s.mtd.billable))} unit="h"
               sub={`${fmt(s.mtd.billablePct)}% of hours logged`} />
          <Kpi label="MTD non-billable" swatch={C.nonBill} value={v(fmt(s.mtd.nonBillable))} unit="h"
               sub="Meetings, training, internal" />
          <Kpi label="Missed timesheets" swatch="#EA7A3A" warn={s.missedDays.length > 0}
               value={v(s.missedDays.length)} unit="days" sub={`${s.ytd.missedDays} missed year to date`} />
          <Kpi label="YTD billable / non-billable" value={v(fmt(s.ytd.billable))} unit={`/ ${fmt(s.ytd.nonBillable)} h`}
               sub={`${fmt(s.ytd.utilization)}% utilization · Jan–${today.toLocaleDateString("en-GB", { month: "short" })}`} />
        </section>

        {/* This month + timesheet status */}
        <section className="grid gap-4 [grid-template-columns:repeat(auto-fit,minmax(340px,1fr))]">

          {/* This month */}
          <Card as="article" className="p-6 flex flex-col gap-5">
            <div className="flex flex-wrap justify-between items-baseline gap-2">
              <h2 className="m-0 text-[18px] font-semibold">{monthName} so far</h2>
              <span className="text-[13px] text-[#5B6474]">{s.mtd.workingDays} working days to date</span>
            </div>
            <div className="flex flex-wrap items-baseline gap-2">
              <span className="text-[40px] font-semibold leading-none">{v(fmt(s.mtd.logged))}</span>
              <span className="text-[15px] text-[#5B6474]">of {fmt(s.mtd.expected)} h expected logged</span>
            </div>
            <div role="img"
              aria-label={`Billable ${fmt(s.mtd.billable)} hours, non-billable ${fmt(s.mtd.nonBillable)} hours, not logged ${fmt(s.mtd.notLogged)} hours, out of ${fmt(s.mtd.expected)} expected`}
              className="flex h-4 rounded-full overflow-hidden bg-[#F1F3F7] gap-0.5">
              <div style={{ width: pct(s.mtd.billable), background: C.primary }} />
              <div style={{ width: pct(s.mtd.nonBillable), background: C.nonBill }} />
              <div style={{ width: pct(s.mtd.notLogged), background: `repeating-linear-gradient(135deg, ${C.warnSoft} 0 6px, ${C.warnBorder} 6px 9px)` }} />
            </div>
            <div className="grid grid-cols-3 gap-3">
              <Legend color={C.primary} label="Billable" value={`${fmt(s.mtd.billable)} h`} />
              <Legend color={C.nonBill} label="Non-billable" value={`${fmt(s.mtd.nonBillable)} h`} />
              <Legend color={C.warnBorder} label="Not logged" value={`${fmt(s.mtd.notLogged)} h`} warn />
            </div>

            <div className="border-t border-[#EEF0F4] pt-4 flex flex-col gap-2.5">
              <h3 className="m-0 text-[14px] font-semibold text-[#3D4555]">Hours by project</h3>
              {s.projects.length === 0 && <p className="m-0 text-[13px] text-[#5B6474]">{loading ? "Loading…" : "No hours logged this month yet."}</p>}
              <div className="flex flex-col gap-2.5 max-h-[260px] overflow-y-auto pr-1">
                {s.projects.map((p) => (
                  <div key={p.name} className="grid grid-cols-[minmax(0,1fr)_64px] gap-x-3 gap-y-1 items-center">
                    <span className="text-[13px] truncate" title={p.name}>{p.name}</span>
                    <span className="text-[13px] font-semibold text-right">{p.hours.toFixed(1)} h</span>
                    <div className="col-span-2 h-1.5 bg-[#F1F3F7] rounded-full">
                      <div className="h-1.5 rounded-full"
                        style={{ width: `${(p.hours / maxProject) * 100}%`, background: p.billableHours >= p.hours / 2 ? C.primary : C.nonBill }} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Card>

          {/* Timesheet status calendar */}
          <Card as="article" className="p-6 flex flex-col gap-[18px]">
            <div className="flex flex-wrap justify-between items-baseline gap-2">
              <h2 className="m-0 text-[18px] font-semibold">Timesheet status</h2>
              <span className="text-[13px] text-[#5B6474]">{monthYear}</span>
            </div>
            <div className="flex flex-col gap-1.5">
              <div className="grid grid-cols-7 gap-1.5" aria-hidden="true">
                {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((d) => (
                  <span key={d} className="text-[11px] text-[#5B6474] text-center">{d}</span>
                ))}
              </div>
              <div className="grid grid-cols-7 gap-1.5" role="list" aria-label={`${monthYear} days`}>
                {s.cells.map((c) => {
                  const clickable = c.status === "missed" || c.status === "today" || c.status === "logged";
                  const title = c.day ? `${shortDate(new Date(c.iso))}: ${CELL_LABEL[c.status]}${c.hours ? ` · ${fmt(c.hours)} h` : ""}` : undefined;
                  return (
                    <div key={c.key} role="listitem" title={title}
                      onClick={clickable ? () => goFill(c.iso) : undefined}
                      className={`h-[34px] rounded-lg flex items-center justify-center text-[12px] font-medium box-border ${CELL[c.status]} ${clickable ? "cursor-pointer hover:brightness-95" : ""}`}>
                      {c.day || ""}
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="flex flex-wrap gap-3.5 text-[12px] text-[#3D4555]">
              <span className="flex items-center gap-1.5"><span aria-hidden="true" className="w-3 h-3 rounded bg-[#E3ECFB]" />Logged</span>
              <span className="flex items-center gap-1.5"><span aria-hidden="true" className="w-3 h-3 rounded bg-[#FDE6D6] border-[1.5px] border-[#EA7A3A] box-border" />Missed</span>
              <span className="flex items-center gap-1.5"><span aria-hidden="true" className="w-3 h-3 rounded border-2 border-[#1D5FD1] box-border" />Today</span>
              <span className="flex items-center gap-1.5"><span aria-hidden="true" className="w-3 h-3 rounded bg-[#F1F3F7]" />Weekend</span>
            </div>

            <div className="border-t border-[#EEF0F4] pt-4 flex flex-col gap-1">
              <h3 className="m-0 mb-1.5 text-[14px] font-semibold text-[#3D4555]">Needs your attention</h3>
              {!loading && s.missedDays.length === 0 && (
                <p className="m-0 text-[13px] text-[#5B6474]">You're all caught up this month.</p>
              )}
              {s.missedDays.map((m, i) => (
                <div key={m.iso} className={`flex items-center justify-between gap-3 py-2 ${i < s.missedDays.length - 1 ? "border-b border-[#F1F3F7]" : ""}`}>
                  <div className="flex flex-col">
                    <span className="text-[14px] font-medium">{shortDate(m.date)}</span>
                    <span className="text-[12px] text-[#5B6474]">No entries · {m.daysOverdue} day{m.daysOverdue === 1 ? "" : "s"} overdue</span>
                  </div>
                  <button type="button" onClick={() => goFill(m.iso)}
                    className="min-h-[44px] px-3.5 rounded-[10px] border border-[#F6C9A8] bg-white text-[#9A3412] text-[13px] font-semibold cursor-pointer hover:bg-[#FFF4EC]">
                    Fill now
                  </button>
                </div>
              ))}
            </div>
          </Card>
        </section>

        {/* Year to date */}
        <Card as="article" className="p-6 flex flex-col gap-5">
          <div className="flex flex-wrap justify-between items-start gap-4">
            <div className="flex flex-col gap-1">
              <h2 className="m-0 text-[18px] font-semibold">Year to date</h2>
              <span className="text-[13px] text-[#5B6474]">
                January – {monthYear} · hours per month
              </span>
            </div>
            <div className="flex flex-wrap gap-7">
              <div className="flex flex-col gap-0.5">
                <span className="text-[12px] text-[#5B6474] flex items-center gap-1.5"><Swatch color={C.primary} />Billable</span>
                <span className="text-[22px] font-semibold">{v(fmt(s.ytd.billable))} h</span>
              </div>
              <div className="flex flex-col gap-0.5">
                <span className="text-[12px] text-[#5B6474] flex items-center gap-1.5"><Swatch color={C.nonBill} />Non-billable</span>
                <span className="text-[22px] font-semibold">{v(fmt(s.ytd.nonBillable))} h</span>
              </div>
              <div className="flex flex-col gap-0.5">
                <span className="text-[12px] text-[#5B6474]">Utilization</span>
                <span className="text-[22px] font-semibold">{v(`${fmt(s.ytd.utilization)}%`)}</span>
              </div>
              <div className="flex flex-col gap-0.5">
                <span className="text-[12px] text-[#9A3412]">Missed days</span>
                <span className="text-[22px] font-semibold text-[#C2410C]">{v(s.ytd.missedDays)}</span>
              </div>
            </div>
          </div>

          <div className="overflow-x-auto">
            <div role="img" aria-label={`Monthly billable and non-billable hours, January to ${monthYear}`}
              className="min-w-[560px] grid gap-3.5 items-end h-[220px] border-b border-[#E6E9EF] px-1"
              style={{ gridTemplateColumns: `repeat(${s.months.length}, minmax(0, 1fr))` }}>
              {s.months.map((m) => {
                const total = m.billable + m.nonBillable;
                return (
                  <div key={m.label} className="flex flex-col items-center justify-end gap-1.5 h-full">
                    <span className="text-[11px] text-[#5B6474] font-medium">{total ? fmt(total) : ""}</span>
                    <div className="w-full max-w-[44px] flex flex-col gap-0.5">
                      {m.nonBillable > 0 && (
                        <div className="rounded-t-md" style={{ height: (m.nonBillable / maxMonth) * CHART_PX, background: C.nonBill }} />
                      )}
                      <div className={m.nonBillable > 0 ? "" : "rounded-t-md"}
                        style={{ height: (m.billable / maxMonth) * CHART_PX, background: C.primary }} />
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="min-w-[560px] grid gap-3.5 pt-2 px-1"
              style={{ gridTemplateColumns: `repeat(${s.months.length}, minmax(0, 1fr))` }}>
              {s.months.map((m) => (
                <span key={m.label} className="text-[12px] text-[#5B6474] text-center">{m.label}</span>
              ))}
            </div>
          </div>
        </Card>

        </>)}

        {/* ── Admin view ── */}
        {adminView && (<>
        {/* Clients → Utilization page */}
        {projState !== "error" && !(projState === "ready" && projects.length === 0) && (
          <Card as="section" aria-label="Clients" className="p-6 flex flex-col gap-4">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div className="flex flex-col gap-1">
                <h2 className="m-0 text-[18px] font-semibold">Clients</h2>
                <span className="text-[13px] text-[#5B6474]">
                  Hours logged in {monthYear} · select a client to see its projects and each person's utilization
                </span>
              </div>
              <div className="flex flex-wrap items-center gap-2">
                <label className="relative block">
                  <FiSearch aria-hidden="true" className="absolute left-3 top-1/2 -translate-y-1/2 text-[#8A93A3]" />
                  <input
                    type="search" placeholder="Search client" value={projSearch}
                    onChange={(e) => setProjSearch(e.target.value)}
                    className="h-10 w-[200px] pl-9 pr-3 rounded-[10px] border border-[#E6E9EF] text-[13px] box-border"
                  />
                </label>
                <button type="button" onClick={() => navigate("/utilization?mode=month&from=dashboard")}
                  className="h-10 px-4 rounded-[10px] border border-[#D5DAE3] bg-white text-[13px] font-medium cursor-pointer hover:bg-[#F8FAFC]">
                  Open utilization
                </button>
              </div>
            </div>

            {projState === "loading" ? (
              <div className="grid gap-3 [grid-template-columns:repeat(auto-fill,minmax(220px,1fr))]">
                {Array.from({ length: 4 }).map((_, i) => <div key={i} className="h-[104px] rounded-[12px] bg-[#F1F3F7] animate-pulse" />)}
              </div>
            ) : projFiltered.length === 0 ? (
              <p className="m-0 text-[13px] text-[#5B6474]">No client matches "{projSearch}".</p>
            ) : (
              <div className="grid gap-3 [grid-template-columns:repeat(auto-fill,minmax(220px,1fr))]">
                {projShown.map((c) => {
                  const billPct = c.total_hours ? (c.billable_hours / c.total_hours) * 100 : 0;
                  return (
                    <button
                      key={c.client_id} type="button" onClick={() => openClient(c.client_id)}
                      className="group text-left bg-white border border-[#E6E9EF] rounded-[12px] p-4 flex flex-col gap-2 cursor-pointer hover:border-[#BFD3F6] hover:shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#1D5FD1]"
                    >
                      <span className="flex items-start justify-between gap-2">
                        <span className="flex flex-col min-w-0">
                          <span className="text-[14px] font-semibold truncate group-hover:text-[#164AA6]">{c.client_name}</span>
                          <span className="text-[12px] text-[#5B6474]">
                            {c.projects_count} active project{c.projects_count === 1 ? "" : "s"}
                          </span>
                        </span>
                        <FiChevronRight aria-hidden="true" className="shrink-0 mt-1 text-[#8A93A3] group-hover:text-[#1D5FD1]" />
                      </span>
                      <span className="flex items-baseline justify-between gap-2">
                        <span className="text-[20px] font-semibold">{fmt(c.total_hours)}<span className="text-[13px] text-[#5B6474] font-medium"> h</span></span>
                        <span className="text-[12px] text-[#5B6474] flex items-center gap-1" title="People who logged hours this month">
                          <FiUsers aria-hidden="true" />{c.people_logged}
                        </span>
                      </span>
                      <span className="h-1.5 bg-[#F1F3F7] rounded-full overflow-hidden">
                        <span className="block h-1.5 rounded-full" style={{ width: `${(c.total_hours / maxProjectHours) * 100}%`, background: C.primary }} />
                      </span>
                      <span className="text-[11px] text-[#5B6474]">{c.total_hours ? `${fmt(billPct)}% billable` : "No hours this month"}</span>
                    </button>
                  );
                })}
              </div>
            )}

            {!projQuery && projFiltered.length > PROJECTS_PREVIEW && (
              <button type="button" onClick={() => setShowAllProjects((x) => !x)}
                className="self-start h-9 px-3 rounded-[10px] border-0 bg-transparent text-[13px] font-semibold text-[#1D5FD1] cursor-pointer hover:bg-[#EEF3FC]">
                {showAllProjects ? "Show fewer" : `Show all ${projFiltered.length} clients`}
              </button>
            )}
          </Card>
        )}

        {/* Organization overview (secondary) */}
        <section aria-label="Organization overview" className="flex flex-col gap-3">
          <h2 className="m-0 text-[14px] font-semibold text-[#5B6474] uppercase tracking-[0.06em]">Organization overview</h2>
          <div className="grid gap-3 [grid-template-columns:repeat(auto-fit,minmax(180px,1fr))]">
            <OrgTile label="Clients" value={org?.clients ?? "…"} />
            <OrgTile label="Projects" value={org?.projects ?? "…"}
              sub={org ? `Ops ${org.opsProjects ?? 0} · One-time ${org.onetimeProjects ?? 0} · Annual ${org.annualProjects ?? 0}` : null} />
            <OrgTile label="Active / inactive projects"
              value={<>{org?.activeProjects ?? "…"} <span className="text-[14px] text-[#5B6474] font-medium">/ {org?.inactiveProjects ?? "…"}</span></>} />
            <OrgTile label="Active employees" value={org?.activeEmployees ?? "…"} />
          </div>
        </section>
        </>)}

      </div>
    </div>
  );
};